import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import PWAPrompt from 'react-ios-pwa-prompt';
import routes from 'src/routes';
import { Switch, useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { renderRoutes } from 'react-router-config';
import { setIpAddress, setSessionToken, setUserSession } from 'src/utils/Common';
import axios2 from 'axios';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Topbar from './Topbar';
import {
  commonActions
} from '../../store/slices/commonSlice';
import NotificationSnackbar from '../../components/NotificationSnackbar';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  }
}));

function Auth() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [Loading, setLoading] = React.useState(true);
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  navigator.geolocation.getCurrentPosition(success, error, options);
  function success(pos) {
    // var crd = pos.coords;
  }

  function error(err) {
  }

  useEffect(() => {
    if (!authState.isPending && authState.isAuthenticated) {
      oktaAuth.getUser().then((info) => {
        if (info === undefined) {
          const fromUri = history.createHref(history.location);
          oktaAuth.signInWithRedirect(fromUri);
        }
        const UserNames = info?.preferred_username.split('@');
        const dataUser = [{
          UserName: UserNames[0],
          TerminalId: '1',
          VersionNr: process.env.REACT_APP_VERSION,
          TerminalIp: '1',
          LanguageId: '1'
        }];
        const configUser = {
          headers: {
            'Content-Type': 'application/json',
            IpAddress: 1,
            'max-age': 86400,
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1; mode=block',
            accessToken: authState.accessToken.accessToken,
            Authorization: `Bearer ${authState.accessToken.accessToken}`
          }
        };

        const Address = `${process.env.REACT_APP_API_URL}/Technician/GetUserAuthorization`;
        axios2.post(Address, dataUser, configUser)
          .then((response) => {
            if (response.data[0].Role < 4) {
              setUserSession(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '', response.data[0]);
              setLoading(false);
              history.push('/Unauthorized');
            } else {
              setSessionToken(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '');
              setIpAddress(1);
              setUserSession(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '', response.data[0]);
              dispatch(commonActions.changeActiveTenant(response.data[0].TenantId));
              setLoading(false);

              history.push('/Dashboard');
            }

          }).catch((error) => {
            setLoading(false);
            history.push('/Unauthorized');
          });
      });
    }
    if (!authState.isPending && !authState.isAuthenticated) {
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect(fromUri);
    }
  }, [
    authState,
    oktaAuth,
    history,
    dispatch
  ]);

  return (
    <>
      <Topbar />      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={null}>
            <NotificationSnackbar />
          </Suspense>

          {Loading
            && (
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{ minHeight: '100vh' }}
              >
                <Typography component="h2" gutterBottom variant="overline">
                  Redirecting
                </Typography>
                <CircularProgress disableShrink />
              </Grid>
            )}
          <PWAPrompt
            promptOnVisit={1}
            timesToShow={3}
            copyTitle="Ana Ekrana Ekle"
            copyBody="Mobil cihazınızın tarayıcısı üzerinden erişebileceğiniz Artemis uygulaması kolayca indirilebilir ve cihazınızda yer kaplamaz."
            copyShareButtonLabel={
              "1) Alt tarafta bulunan 'Paylaş' ikonuna dokunun"
            }
            copyAddHomeButtonLabel={
              "2) Açılan menüde bulunan 'Ana Ekrana Ekle'ye tıklayın"
            }
            copyClosePrompt="Kapat"
            permanentlyHideOnDismiss={false}
          />
          <Suspense fallback={null}>
            <Switch>{renderRoutes(routes)}</Switch>
          </Suspense>

        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
